import { ReactComponent as areaIcon } from '../../assets/images/icons/areaIcon.svg';
import { ReactComponent as userMangementIcon } from '../../assets/images/icons/userManagementIcon.svg';
import { ReactComponent as logsIcon } from '../../assets/images/icons/logsIcon.svg';
import { ReactComponent as employeeIcon } from '../../assets/images/icons/Employees.svg';
import { ReactComponent as departmentIcon } from '../../assets/images/icons/DepartmentIcon.svg';
import { ReactComponent as dashboardIcon } from '../../assets/images/icons/dashboardIcon.svg';
import { ReactComponent as mapViewIcon } from '../../assets/images/icons/mapView.svg';


const icons: any = {
    dashboard: dashboardIcon,
    Area: areaIcon,
    userManagement: userMangementIcon,
    informationManagement: logsIcon,
    EmployeeId: employeeIcon,
    Departments: departmentIcon,
    adminMapView: mapViewIcon,
    nodalOfficerMapView: mapViewIcon
};

export default icons;
